import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../store/hooks'
import { buildRelativePath, PathConfig } from '../../core/config/PathConfig'
import AnalyticDetailsLayout from '../../components/analytics-details-v2/AnalyticDetailsLayout'
import { InfluencerDetails } from '../../core/interface/chronique.interface'
import GetInfluencers from '../../core/api/services/bookmetrie/private-reports/chroniqueur/get-influencers.service'
import Influencer from '../../components/chroniqueur/influencer-view/Influencer'
import { setShowSnackBar } from '../../store/reducers/web-app.reducer'

const InfluencersView = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [influencers, setInfluencers] = useState<InfluencerDetails[]>([])

  useEffect(() => {
    setIsLoading(true)
    GetInfluencers()
      .then((response) => {
        setInfluencers(response.data)
      })
      .catch(() => {
        dispatch(setShowSnackBar(t('snackbarMessage.errorMessage')))
      })
      .finally(() => setIsLoading(false))
  }, [])

  const backToPrivateReports = () => {
    navigate(
      buildRelativePath([PathConfig.BOOKMETRIE, PathConfig.PRIVATE_REPORTS]),
    )
  }

  // Convertir les données pour le tableau

  return (
    <AnalyticDetailsLayout
      analyticName={t('chroniqueurView.fakeTitle')}
      handleRenameAnalytic={() => {}}
      handleExitAnalyticDetails={backToPrivateReports}
      isLoading={isLoading}
      hasButtonPrevious={false}
    >
      <Influencer data={influencers} />
    </AnalyticDetailsLayout>
  )
}

export default InfluencersView
